import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";

const COLORS = [
  "#3b82f6", "#6366f1", "#8b5cf6", "#a855f7",
  "#ec4899", "#f43f5e", "#f97316", "#eab308",
  "#22c55e", "#14b8a6",
];

const tooltipStyle = {
  contentStyle: {
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
    fontSize: "13px",
  },
};

const RecipientMessagesCard = React.memo(({ data }) => {
  const { chartData, total } = useMemo(() => {
    if (!data || !data.length) return { chartData: [], total: 0 };

    const sorted = [...data]
      .sort((a, b) => (b.messages_sent || 0) - (a.messages_sent || 0))
      .slice(0, 15);

    const total = data.reduce((sum, d) => sum + (d.messages_sent || 0), 0);
    return { chartData: sorted, total };
  }, [data]);

  const barHeight = Math.max(chartData.length * 38, 120);

  return (
    <div className="overview-metric-card overview-metric-card--wide">
      <div className="metric-header">
        <div className="metric-info">
          <h4 className="metric-title">Messages Sent by user</h4>
          <div className="metric-total">
            <span>{total.toLocaleString()}</span>
          </div>
          <div className="metric-details">
            <span className="metric-avg">{chartData.length} user{chartData.length !== 1 ? "s" : ""}</span>
          </div>
        </div>
      </div>
      <div className="metric-chart">
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={barHeight}>
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={false} />
              <XAxis
                type="number"
                tick={{ fontSize: 11, fill: "#94a3b8" }}
                axisLine={{ stroke: "#e2e8f0" }}
                tickLine={false}
                allowDecimals={false}
              />
              <YAxis
                type="category"
                dataKey="name"
                tick={{ fontSize: 12, fill: "#475569" }}
                axisLine={false}
                tickLine={false}
                width={120}
              />
              <Tooltip {...tooltipStyle} />
              <Bar dataKey="messages_sent" name="Messages Sent" radius={[0, 4, 4, 0]}>
                {chartData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="metric-no-data">No recipient data for this period</div>
        )}
      </div>
    </div>
  );
});

RecipientMessagesCard.displayName = "RecipientMessagesCard";

export default RecipientMessagesCard;
